<template>
  <div class="mdb-admin-sidenav tys-skin black-skin">
    <mdb-side-nav
      :OpenedFromOutside.sync="toggle"
    >
      <li class="ripple-parent">
        <div class="logo-wrapper text-center">
        <router-link to="/" class="pl-0">
          <img :src="require('../assets/tys_logo_white.svg')" class="img-fluid">
        </router-link>
        </div>
      </li>
<!--      <li>-->
<!--        <form class="search-form" role="search">-->
<!--          <div class="form-group md-form mt-0 pt-1 ripple-parent" @click="wave">-->
<!--            <input type="text" class="form-control" placeholder="Search" />-->
<!--          </div>-->
<!--        </form>-->
<!--      </li>-->
      <li>
        <mdb-side-nav-nav>
          <mdb-side-nav-cat name="О Компании" icon="building">
            <mdb-side-nav-item
                    to="/infos/about"
                    @click.native="width < 1440 && toggleSideNav(false)">
              О компании
            </mdb-side-nav-item>
            <mdb-side-nav-item
                    to="/infos/history"
                    @click.native="width < 1440 && toggleSideNav(false)">
              История компании
            </mdb-side-nav-item>
            <mdb-side-nav-item
                    to="/infos/rukovodstvo"
                    @click.native="width < 1440 && toggleSideNav(false)">
              Руководство
            </mdb-side-nav-item>
            <mdb-side-nav-item
                    to="/infos/filial"
                    @click.native="width < 1440 && toggleSideNav(false)">
              Филиалы
            </mdb-side-nav-item>
            <mdb-side-nav-item
                    to="/infos/partner"
                    @click.native="width < 1440 && toggleSideNav(false)">
              Партнеры
            </mdb-side-nav-item>
            <mdb-side-nav-item
                    to="/infos/sertificates"
                    @click.native="width < 1440 && toggleSideNav(false)">
              Сертификаты
            </mdb-side-nav-item>
            <mdb-side-nav-item
                    to="/infos/agent"
                    @click.native="width < 1440 && toggleSideNav(false)">
              Страховые агенты
            </mdb-side-nav-item>
          </mdb-side-nav-cat>
          <mdb-side-nav-cat name="Новости" icon="book" >
            <mdb-side-nav-item v-for="cat in newsCategories" :key="cat.id"
                               :to="'/news/category/' + cat.id"
                               @click.native="width < 1440 && toggleSideNav(false)">
              {{ cat.title }}
            </mdb-side-nav-item>
          </mdb-side-nav-cat>
          <mdb-side-nav-cat name="Страховая документация" icon="book" >
            <mdb-side-nav-item v-for="group in productGroupsOrdered" :key="group.id"
                    :to="'/products/group/' + group.id"
                    @click.native="width < 1440 && toggleSideNav(false)" :title="group.name">
              {{ group.name }}
            </mdb-side-nav-item>
          </mdb-side-nav-cat>
          <mdb-side-nav-item
              icon="book"
              to="/takaful"
              @click.native="width < 1440 && toggleSideNav(false)">
            Исламское страхование
          </mdb-side-nav-item>
          <mdb-side-nav-item
                  icon="cogs"
                  to="/smk/smk"
                  @click.native="width < 1440 && toggleSideNav(false)">
            СМК
          </mdb-side-nav-item>
<!--          <mdb-side-nav-cat name="СМК" icon="cogs">-->
<!--            <mdb-side-nav-item-->
<!--              to="/smk/smk"-->
<!--              @click.native="width < 1440 && toggleSideNav(false)">-->
<!--                СМК-->
<!--            </mdb-side-nav-item>-->
<!--            <mdb-side-nav-item-->
<!--                    to="/smk/kachestvo"-->
<!--                    @click.native="width < 1440 && toggleSideNav(false)">-->
<!--              Руководство по качеству-->
<!--            </mdb-side-nav-item>-->
<!--            <mdb-side-nav-item-->
<!--                    to="/smk/reglament"-->
<!--                    @click.native="width < 1440 && toggleSideNav(false)">-->
<!--              Регламенты СМК-->
<!--            </mdb-side-nav-item>-->
<!--            <mdb-side-nav-item-->
<!--                    to="/smk/procedur"-->
<!--                    @click.native="width < 1440 && toggleSideNav(false)">-->
<!--              Процедуры СМК-->
<!--            </mdb-side-nav-item>-->
<!--            <mdb-side-nav-item-->
<!--                    to="/smk/formular"-->
<!--                    @click.native="width < 1440 && toggleSideNav(false)">-->
<!--              Формуляры СМК-->
<!--            </mdb-side-nav-item>-->
<!--          </mdb-side-nav-cat>-->
          <mdb-side-nav-cat name="Аналитика" icon="cogs">
            <mdb-side-nav-item
                    to="/"
                    @click.native="width < 1440 && toggleSideNav(false)">
              Общее
            </mdb-side-nav-item>
          </mdb-side-nav-cat>
          <mdb-side-nav-item
                  icon="user"
                  to="/infos/recommendation"
                  @click.native="width < 1440 && toggleSideNav(false)">
            Рекомендация пользователя
          </mdb-side-nav-item>
          <!-- template pages for dev mode only-->
          <mdb-side-nav-cat v-if="mode == 'development'" name="Dashboards" icon="tachometer-alt">
            <mdb-side-nav-item
              to="/dashboards/v-1"
              @click.native="width < 1440 && toggleSideNav(false)"
              >Version 1</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/dashboards/v-2"
              @click.native="width < 1440 && toggleSideNav(false)"
              >Version 2</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/dashboards/v-3"
              @click.native="width < 1440 && toggleSideNav(false)"
              >Version 3</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/dashboards/v-4"
              @click.native="width < 1440 && toggleSideNav(false)"
              >Version 4</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/dashboards/v-5"
              @click.native="width < 1440 && toggleSideNav(false)"
              >Version 5</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/dashboards/v-6"
              @click.native="width < 1440 && toggleSideNav(false)"
              >Version 6</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat v-if="mode == 'development'" name="Pages" icon="image">
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              target="_blank"
              to="/pages/login"
              >Login</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              target="_blank"
              to="/pages/register"
              >Register</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              target="_blank"
              to="/pages/pricing"
              >Pricing</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              target="_blank"
              to="/pages/about"
              >About us</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              target="_blank"
              to="/pages/single"
              >Single post</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              target="_blank"
              to="/pages/post"
              >Post listing</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              target="_blank"
              to="/pages/landing"
              >Landing Page</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/pages/customers"
              >Customers</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/pages/invoice"
              >Invoice</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/pages/page"
              >Page Creator</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/pages/support"
              >Support</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/pages/chat"
              >Chat</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat v-if="mode == 'development'" name="Profile" icon="user">
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/profiles/basic-1"
              >Basic 1</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/profiles/basic-2"
              >Basic 2</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/profiles/extended"
              >Extended</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat v-if="mode == 'development'" name="CSS" fab icon="css3">
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/grid"
              >Grid system</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/media"
              >Media object</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/utilities"
              >Utilities / helpers</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/code"
              >Code</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/icons"
              >Icons</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/images"
              >Images</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/typo"
              >Typography</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/colors"
              >Colors</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/hover"
              >Hover effects</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/masks"
              >Masks</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/shadows"
              >Shadows</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/css/skins"
              >Skins</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat v-if="mode == 'development'" name="Components" icon="th">
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/buttons"
              >Buttons</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/cards"
              >Cards</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/panels"
              >Panels</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/list"
              >List group</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/pagination"
              >Pagination</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/progress"
              >Progress bars</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/tabs"
              >Tabs & pills</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/tags"
              >Tags, labels & badges</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/collapse"
              >Collapse</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/datepicker"
              >Date picker</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/timepicker"
              >Time picker</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/tooltips"
              >Tooltips</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/popovers"
              >Popovers</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/components/stepper"
              >Stepper</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat v-if="mode == 'development'" name="Forms" far icon="check-square">
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/forms/basic"
              >Basic</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/forms/extended"
              >Extended</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat v-if="mode == 'development'" name="Tables" icon="table">
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/tables/basic"
              >Basic</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/tables/extended"
              >Extended</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/tables/datatables"
              >DataTables</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat v-if="mode == 'development'" name="Maps" icon="map">
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/maps/googlemaps"
              >Google Maps</mdb-side-nav-item
            >
            <mdb-side-nav-item
              class="ripple-parent"
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/maps/fullscreen"
              >Full screen map</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-item v-if="mode == 'development'"
            header
            @click.native="width < 1440 && toggleSideNav(false)"
            icon="bolt"
            to="/modals/modals"
            >Modals</mdb-side-nav-item
          >
          <mdb-side-nav-item v-if="mode == 'development'"
            header
            @click.native="width < 1440 && toggleSideNav(false)"
            icon="chart-pie"
            to="/charts/charts"
            >Charts</mdb-side-nav-item
          >
          <mdb-side-nav-item v-if="mode == 'development'"
            header
            @click.native="width < 1440 && toggleSideNav(false)"
            far
            icon="calendar-check"
            to="/calendar/calendar"
            >Calendar</mdb-side-nav-item
          >
          <mdb-side-nav-item v-if="mode == 'development'"
            header
            @click.native="width < 1440 && toggleSideNav(false)"
            icon="th-large"
            to="/sections/sections"
            >Sections</mdb-side-nav-item
          >
        </mdb-side-nav-nav>
      </li>
    </mdb-side-nav>
  </div>
</template>

<script>
import {
  mdbSideNav,
  mdbSideNavNav,
  mdbSideNavCat,
  mdbSideNavItem,
  waves
} from "mdbvue";
import { mapGetters, mapActions } from "vuex";
import axios from 'axios';
import _ from 'lodash';
export default {
  name: "SideNav",
  props: {
    waves: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean
    }
  },
  components: {
    mdbSideNav,
    mdbSideNavNav,
    mdbSideNavCat,
    mdbSideNavItem
  },
  data() {
    return {
      active: 0,
      elHeight: 0,
      windowHeight: 0,
      toggle: true,
      width: 0,
      productGroups: null,
      newsCategories: null,
      mode: process.env.NODE_ENV
    };
  },
  computed: {
      ...mapGetters(["sidenav"]),
      productGroupsOrdered() {
          return _.orderBy(this.productGroups, 'id');
      }
  },
  methods: {
    ...mapActions(["toggleSideNav"]),
    afterEnter(el) {
      el.style.maxHeight = "1000px";
    },
    beforeLeave(el) {
      el.style.maxHeight = 0;
    },
    setWidth() {
      this.width = window.innerWidth;
    }
  },
  mounted() {
    this.setWidth();
    window.addEventListener("resize", this.setWidth);
    axios.get(process.env.VUE_APP_CONTENT_URL + '/product-groups?token=' + process.env.VUE_APP_CONTENT_REST_TOKEN, {headers:{Authorization: ''}})
        .then(response => (this.productGroups = response.data));
    axios.get(process.env.VUE_APP_CONTENT_URL + '/news-categories?token=' + process.env.VUE_APP_CONTENT_REST_TOKEN, {headers:{Authorization: ''}})
            .then(response => (this.newsCategories = response.data));
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWidth);
  },
  watch: {
    toggle(value) {
      this.toggleSideNav(value);
    },
    sidenav(value) {
      this.toggle = value;
    },
    width(value) {
      if (value < 1440) {
        this.toggle = false;
      } else this.toggle = true;
    }
  },
  mixins: [waves]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.side-nav {
  opacity: 1 !important;
  transition: transform 0.3s linear !important;
}
</style>
